import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const useGetPartenaires = ({ params, action = 'getPartenaires', orderBy }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [partenaireList, setPartenaireList] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    const getPartenaires = async () => {

        const orderByQs = orderBy ? `&order_by=${encodeURIComponent(orderBy)}` : '';
        await fetch(`${apiUrlTranslation}?action=${action}&params=${params}${orderByQs}`)
            .then(res => res.json())
            .then(res => setPartenaireList(res))
    }

    useEffect(() => {
        getPartenaires().then(() => {
            setIsLoading(false);
        });

    }, [i18n.resolvedLanguage])

    return { partenaireList, isLoading }
}

export default useGetPartenaires;